var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[(_vm.signatureUrl)?_c('div',[_c('img',{staticClass:"-rotate-90 ml-32 transform",attrs:{"src":_vm.signatureUrl,"alt":"Signature"}})]):_c('div',[_vm._v(" Pas de signature pour cette livraison. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }